module.exports = __webpack_public_path__ + "media/images/athletes/1670-b5def0f9a86f50fc261aae38d6fe3818.png";